import axios from "axios";
import moment from "moment";

var store = {
  debug: true,
  state: {
    scales: [],
    scaleView: {
      createModeActive: false,
      editModeActive: false,
      editedScale: {}
    },
    waistView: {
      sortingOptions: [
        "Newest first",
        "Oldest first",
        "Highest measurement first",
        "Lowest measurement first"
      ],
      selectedSortingOption: "Newest first",
      cancelRoute: ""
    },
    weightView: {
      sortingOptions: [
        "Newest first",
        "Oldest first",
        "Highest weight first",
        "Lowest weight first"
      ],
      selectedSortingOption: "Newest first",
      cancelRoute: ""
    },
    bloodSugarView: {
      sortingOptions: [
        "Newest first",
        "Oldest first",
        "Highest measurement first",
        "Lowest measurement first"
      ],
      selectedSortingOption: "Newest first",
      cancelRoute: ""
    },
    bloodPressureView: {
        sortingOptions: [
          "Newest first",
          "Oldest first",
          "Highest systolic pressure first",
          "Lowest systolic pressure first",
          "Highest diastolic pressure first",
          "Lowest diastolic pressure first",
        ],
        selectedSortingOption: "Newest first",
        cancelRoute: ""
      },
    waistMeasurements: [],
    weighingResults: [],
    alertCounter: 0,
    alerts: [],
    dataState: {
      waistData: false,
      weightData: false,
      scaleData: false,
      bloodSugarData: false,
      bloodPressureData: false
    }
  },
  clear() {
    (this.state.scales = []),
      (this.state.scaleView = {
        createModeActive: false,
        editModeActive: false,
        editedScale: {}
      });
    this.state.waistMeasurements = [];
    this.state.weighingResults = [];
    this.state.bloodSugarMeasurements = [];
    this.state.bloodPressureMeasurements = [];
    this.state.alertCounter = 0;
    this.state.alerts = [];
    this.state.dataState = {
      waistData: false,
      weightData: false,
      scaleData: false,
      bloodSugarData: false,
      bloodPressureData: false
    };
  },
  fetchData() {
    this.fetchWeighingResults();
    this.fetchWaistMeasurements();
    this.fetchScales();
    this.fetchBloodSugarMeasurements();
    this.fetchBloodPressureMeasurements();
  },
  dataFetched() {
    return (
      this.state.dataState.waistData &&
      this.state.dataState.weightData &&
      this.state.dataState.scaleData &&
      this.state.dataState.bloodSugarData &&
      this.state.dataState.bloodPressureData
    );
  },
  hasMeasurementsInStore() {
    return (
      this.getWaistMeasurementCount() > 0 || this.getWeighingResultsCount() > 0
    );
  },
  setMessageAction(newValue) {
    if (this.debug) console.log("setMessageAction triggered with", newValue);
    this.state.message = newValue;
  },
  clearMessageAction() {
    if (this.debug) console.log("clearMessageAction triggered");
    this.state.message = "";
  },
  fetchScales(callback) {
    var self = this;
    axios
      .get("/scale")
      .then(function(response) {
        self.state.scales = response.data;
        self.state.dataState.scaleData = true;

        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  getScales() {
    return this.state.scales;
  },
  getScalesCount() {
    return this.state.scales.length;
  },
  getFirstScale() {
    if (this.state.scales.length == 0) {
      return null;
    }

    return this.state.scales[0];
  },
  getScale(scaleId) {
    return this.state.scales.find(function(scale) {
      if (scale.id == scaleId) {
        return scale;
      }
    });
  },
  removeScale(scaleId) {
    // Set all weighing result references to null
    for (let i = 0; i < this.state.weighingResults.length; i++) {
      if (this.state.weighingResults[i].scale_id == scaleId) {
        this.state.weighingResults[i].scale_id = null;
      }
    }

    for (let i = 0; i < this.state.scales.length; i++) {
      if (this.state.scales[i].id == scaleId) {
        this.state.scales.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  activateScaleEditMode(scale) {
    this.state.scaleView.createModeActive = false;
    this.state.scaleView.editModeActive = true;
    this.state.scaleView.editedScale = JSON.parse(JSON.stringify(scale));
  },
  deactivateScaleEditMode() {
    this.state.scaleView.editModeActive = false;
    this.state.scaleView.editedScale = {};
  },
  isScaleEditModeActive() {
    return this.state.scaleView.editModeActive;
  },
  activateScaleCreateMode() {
    this.state.scaleView.editModeActive = false;
    this.state.scaleView.createModeActive = true;
  },
  deactivateScaleCreateMode() {
    this.state.scaleView.createModeActive = false;
  },
  isScaleCreateModeActive() {
    return this.state.scaleView.createModeActive;
  },

  /*
   * Waist measurement
   */
  fetchWaistMeasurements(callback) {
    var self = this;
    axios
      .get("/waist")
      .then(function(response) {
        self.state.waistMeasurements = response.data;
        self.state.dataState.waistData = true;

        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  getWaistMeasurement(waistMeasurementId) {
    return this.state.waistMeasurements.find(function(waistMeasurement) {
      if (waistMeasurement.id == waistMeasurementId) {
        return waistMeasurement;
      }
    });
  },
  getWaistMeasurements() {
    return this.state.waistMeasurements;
  },
  getWaistMeasurementCount() {
    return this.state.waistMeasurements.length;
  },
  addWaistMeasurement(waistMeasurement) {
    this.state.waistMeasurements.push(waistMeasurement);
  },
  updateWaistMeasurement(updatedWaistMeasurement) {
    for (let i = 0; i < this.state.waistMeasurements.length; i++) {
      if (this.state.waistMeasurements[i].id == updatedWaistMeasurement.id) {
        this.state.waistMeasurements[i] = JSON.parse(
          JSON.stringify(updatedWaistMeasurement)
        );
        return true;
      }
    }

    return false;
  },
  removeWaistMeasurement(waistMeasurementId) {
    for (let i = 0; i < this.state.waistMeasurements.length; i++) {
      if (this.state.waistMeasurements[i].id == waistMeasurementId) {
        this.state.waistMeasurements.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  storeWaistMeasurement(waistMeasurement) {
    var self = this;
    axios
      .post("/waist", waistMeasurement)
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchWaistMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  deleteWaistMeasurement(waistMeasurementId) {
    var self = this;
    axios
      .delete("/waist/" + parseInt(waistMeasurementId))
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchWaistMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  /*
   * BloodSugar measurement
   */
  fetchBloodSugarMeasurements(callback) {
    var self = this;
    axios
      .get("/bloodsugar")
      .then(function(response) {
        self.state.bloodSugarMeasurements = response.data;
        self.state.dataState.bloodSugarData = true;

        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  getBloodSugarMeasurement(bloodSugarMeasurementId) {
    return this.state.bloodSugarMeasurements.find(function(
      bloodSugarMeasurement
    ) {
      if (bloodSugarMeasurement.id == bloodSugarMeasurementId) {
        return bloodSugarMeasurement;
      }
    });
  },
  getBloodSugarMeasurements() {
    return this.state.bloodSugarMeasurements;
  },
  getBloodSugarMeasurementCount() {
    return this.state.bloodSugarMeasurements.length;
  },
  addBloodSugarMeasurement(bloodSugarMeasurement) {
    this.state.bloodSugarMeasurements.push(bloodSugarMeasurement);
  },
  updateBloodSugarMeasurement(updatedBloodSugarMeasurement) {
    for (let i = 0; i < this.state.bloodSugarMeasurements.length; i++) {
      if (
        this.state.bloodSugarMeasurements[i].id ==
        updatedBloodSugarMeasurement.id
      ) {
        this.state.bloodSugarMeasurements[i] = JSON.parse(
          JSON.stringify(updatedBloodSugarMeasurement)
        );
        return true;
      }
    }

    return false;
  },
  removeBloodSugarMeasurement(bloodSugarMeasurementId) {
    for (let i = 0; i < this.state.bloodSugarMeasurements.length; i++) {
      if (this.state.bloodSugarMeasurements[i].id == bloodSugarMeasurementId) {
        this.state.bloodSugarMeasurements.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  storeBloodSugarMeasurement(bloodSugarMeasurement) {
    var self = this;
    axios
      .post("/bloodsugar", bloodSugarMeasurement)
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchBloodSugarMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  deleteBloodSugarMeasurement(bloodSugarMeasurementId) {
    var self = this;
    axios
      .delete("/bloodsugar/" + parseInt(bloodSugarMeasurementId))
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchBloodSugarMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  /*
   * BloodPressure measurement
   */
  fetchBloodPressureMeasurements(callback) {
    var self = this;
    axios
      .get("/bloodpressure")
      .then(function(response) {
        self.state.bloodPressureMeasurements = response.data;
        self.state.dataState.bloodPressureData = true;

        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  getBloodPressureMeasurement(bloodPressureMeasurementId) {
    return this.state.bloodPressureMeasurements.find(function(
      bloodPressureMeasurement
    ) {
      if (bloodPressureMeasurement.id == bloodPressureMeasurementId) {
        return bloodPressureMeasurement;
      }
    });
  },
  getBloodPressureMeasurements() {
    return this.state.bloodPressureMeasurements;
  },
  getBloodPressureMeasurementCount() {
    return this.state.bloodPressureMeasurements.length;
  },
  addBloodPressureMeasurement(bloodPressureMeasurement) {
    this.state.bloodPressureMeasurements.push(bloodPressureMeasurement);
  },
  updateBloodPressureMeasurement(updatedBloodPressureMeasurement) {
    for (let i = 0; i < this.state.bloodPressureMeasurements.length; i++) {
      if (
        this.state.bloodPressureMeasurements[i].id ==
        updatedBloodPressureMeasurement.id
      ) {
        this.state.bloodPressureMeasurements[i] = JSON.parse(
          JSON.stringify(updatedBloodPressureMeasurement)
        );
        return true;
      }
    }

    return false;
  },
  removeBloodPressureMeasurement(bloodPressureMeasurementId) {
    for (let i = 0; i < this.state.bloodPressureMeasurements.length; i++) {
      if (
        this.state.bloodPressureMeasurements[i].id == bloodPressureMeasurementId
      ) {
        this.state.bloodPressureMeasurements.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  storeBloodPressureMeasurement(bloodPressureMeasurement) {
    var self = this;
    axios
      .post("/bloodpressure", bloodPressureMeasurement)
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchBloodPressureMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  deleteBloodPressureMeasurement(bloodPressureMeasurementId) {
    var self = this;
    axios
      .delete("/bloodpressure/" + parseInt(bloodPressureMeasurementId))
      .then(function(response) {
        // handle success
        console.log(response);
        self.fetchBloodPressureMeasurements();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  compareByDatetimeOldestFirst(a, b) {
    let aDateTime;
    let bDateTime;

    if (a.time) aDateTime = moment(a.date + " " + a.time);
    else aDateTime = moment(a.date);

    if (b.time) bDateTime = moment(b.date + " " + b.time);
    else bDateTime = moment(b.date);

    if (aDateTime < bDateTime) {
      return -1;
    }

    if (aDateTime > bDateTime) {
      return 1;
    }

    return 0;
  },
  compareByMeasurementHighestFirst(a, b) {
    if (a > b) {
      return -1;
    }

    if (a < b) {
      return 1;
    }

    return 0;
  },
  /*
   * Weighing result
   */
  fetchWeighingResults(callback) {
    var self = this;
    axios
      .get("/weight")
      .then(function(response) {
        self.state.weighingResults = response.data;
        self.state.dataState.weightData = true;
        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  },
  getWeighingResult(weighingResultId) {
    return this.state.weighingResults.find(function(weighingResult) {
      if (weighingResult.id == weighingResultId) {
        return weighingResult;
      }
    });
  },
  getWeighingResults() {
    return this.state.weighingResults;
  },
  getWeighingResultsCount() {
    return this.state.weighingResults.length;
  },
  addWeighingResult(weighingResult) {
    this.state.weighingResults.push(weighingResult);
  },
  updateWeighingResult(updatedWeighingResult) {
    for (let i = 0; i < this.state.weighingResults.length; i++) {
      if (this.state.weighingResults[i].id == updatedWeighingResult.id) {
        this.state.weighingResults[i] = JSON.parse(
          JSON.stringify(updatedWeighingResult)
        );
        return true;
      }
    }

    return false;
  },
  removeWeighingResult(weighingResultId) {
    for (let i = 0; i < this.state.weighingResults.length; i++) {
      if (this.state.weighingResults[i].id == weighingResultId) {
        this.state.weighingResults.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  getMeasurementDatetime(measurement) {
    if (measurement.date) {
      if (measurement.time) {
        return moment(measurement.date + " " + measurement.time);
      }

      return moment(measurement.date);
    }

    return undefined;
  },

  // Alerts
  addAlert(text, variant) {
    var alert = {
      id: this.state.alertCounter++,
      text: text,
      variant: variant
    };

    this.state.alerts.push(alert);
  },
  handleLaravelAlertResponse(error) {
    var self = this;
    Object.values(JSON.parse(error.response.data)).forEach(errors => {
      for (let i = 0; i < errors.length; i++)
        self.addAlert(errors[i], "danger");
    });
  },
  dismissAlert(alert) {
    for (var i = 0; i < this.state.alerts.length; i++) {
      if (this.state.alerts[i] == alert) {
        this.state.alerts.splice(i, 1);
        return true;
      }
    }

    return false;
  },
  clearAlerts() {
    console.log("Clearing alarms...");
    this.state.alerts.length = 0;
  }
};

export { store };
